module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/stitched-accents-c89861a44bc1683acc3159d13029da8b.jpg";